import { Link } from "react-router-dom";
import { PublicHeader, Footer } from "@/components/layout/PublicHeader";

const TBC = "To be confirmed";

const CONTENT = {
  privacy: {
    title: "Privacy",
    sections: [
      ["Who we are", [`Genesis Members Club is operated by: ${TBC}. Registered address: ${TBC}. Country: ${TBC}.`]],
      ["What we collect", [
        "Account details: name, email address, password (stored only as a secure hash) and home city.",
        "Application details depend on the track you apply on. Women's applications include 2–5 photos. Men's applications include a self-declared net-worth band, occupation and, optionally, company, LinkedIn profile and a reference. Any applicant may add an Instagram handle.",
        "Profile details you choose to share, such as a profile photo, interests and a short bio.",
        "Activity inside the members' area: experiences you create or join, contribution plans, requests and private messages.",
      ]],
      ["How applications are screened", [
        "Every application is privately screened by the club's admin team before access is granted.",
        "Admins may record a private rating and notes about each application. These are never shown to the applicant or to other members, and no decision is made automatically.",
        "Application photos and screening details are visible only to admins. Members see only the profile details you choose to share.",
      ]],
      ["Who can see your information", [
        "Your email address is never shown to other members.",
        "Private messages and planning details are visible only to the people taking part.",
        `Service providers that host the site and store photos process data on our behalf: ${TBC}.`,
      ]],
      ["Cookies and analytics", [
        "Essential: access_token and refresh_token keep you signed in (secure, HTTP-only). Your cookie choice is saved in your browser as tgo_consent. These are needed for the site to work.",
        "Optional analytics: only if you choose \"Accept analytics\", we use PostHog (loaded via ap.emergent.sh) to understand how the site is used, including session recordings of pages you visit. Nothing is collected before you accept, and choosing \"Essential only\" stops it and removes its stored data.",
        "Hosting platform: our hosting provider sets __emg_vid (up to 1 year) and __emg_sid (30 minutes) to operate and secure the service.",
        "We don't use advertising cookies. You can change your choice at any time with \"Cookie settings\" in the footer or on your profile page.",
      ]],
      ["How long we keep data", [`Retention periods for applications, photos and closed accounts: ${TBC}.`]],
      ["Your rights", ["You can ask to access, correct or delete your data by emailing welcome@genesismembersclub.com."]],
    ],
  },
  terms: {
    title: "Terms",
    sections: [
      ["Who runs the club", [`Operator: ${TBC}. Registered address: ${TBC}.`]],
      ["Eligibility and screening", [
        "Membership is for adults aged 18 or over, and is subject to approval.",
        "Every application is privately screened, and the club may approve or decline any application at its discretion.",
        "Information you give in your application, including any self-declared details, must be true and your own.",
      ]],
      ["Using the club", [
        "Treat other members with respect, act lawfully and never pressure anyone.",
        "Only upload photos and content you have the right to share.",
        "The club may suspend or remove accounts that break these terms.",
      ]],
      ["Planning only", [
        "Genesis Members Club is a planning space. It doesn't process bookings or payments.",
        "Contributions agreed between members, and any bookings or payments, are arranged outside the platform between the people involved.",
        "Experiences labelled 'Illustrative concept' are examples only and can't be booked.",
      ]],
      ["Liability and governing law", [`Liability terms: ${TBC}. Governing law and jurisdiction: ${TBC}.`]],
    ],
  },
  contact: {
    title: "Contact",
    sections: [
      ["Get in touch", ["Email: welcome@genesismembersclub.com.", `Operator: ${TBC}.`, `Registered address: ${TBC}.`]],
      ["Members", ["Approved members can message other members from inside the members' area.", "Membership applications are privately screened before access is granted."]],
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  return (
    <div data-testid={`legal-${page}`}>
      <PublicHeader />
      <main className="shell max-w-[760px] py-20">
        <p className="eyebrow mb-4">Genesis Members Club</p>
        <h1 className="font-display text-5xl sm:text-6xl">{c.title}</h1>
        <p className="mt-4 text-sm text-muted-foreground">Details marked "{TBC}" will be completed by the club before public launch.</p>
        <div className="mt-10 space-y-10">
          {c.sections.map(([heading, paras]) => (
            <section key={heading}>
              <h2 className="font-display text-2xl sm:text-3xl">{heading}</h2>
              <div className="mt-3 space-y-3 text-foreground/85">{paras.map((p) => <p key={p}>{p}</p>)}</div>
            </section>
          ))}
        </div>
        <Link to="/" className="btn-link mt-12" data-testid="legal-home-link">Back to home</Link>
      </main>
      <Footer />
    </div>
  );
}

export const NotFound = () => (
  <div data-testid="not-found-page">
    <PublicHeader />
    <main className="shell py-32">
      <h1 className="font-display text-6xl">Page not found.</h1>
      <Link to="/" className="btn-primary mt-8" data-testid="not-found-home">Back to home</Link>
    </main>
  </div>
);
